import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_FI: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Kuntoilu',
  components_header_media_1: 'Miehille',
  components_header_media_2: 'Naisille',
  components_header_media_multi_content_2: 'Jooga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Treenaa fiksummin, voi paremmin.',
  hero_button_text: 'Aloita nyt',
  components_ressources_subheader_text: 'Oppaat ja vinkit',
  components_ressources_span_text: 'Se yhdistää joogan maanläheisen lähestymistavan, Pilateksen hallitun tarkkuuden ja voimaharjoittelun dynaamisen haasteen tukeakseen monipuolista ja terveellistä elämäntapaa.',
  components_ressources_card_1_title: 'Joogavinkkejä',
  components_ressources_card_1_text: 'Pikaopas parempaan tasapainoon, hengitykseen ja flow-rytmiin.',
  components_ressources_card_2_title: 'Pilates-vinkkejä',
  components_ressources_card_2_text: 'Yksinkertaisia ​​vinkkejä keskivartalon lihasten vahvistamiseen ja hallinnan parantamiseen.',
  components_notes_and_google_title_1: 'Rakenna voimaa',
  components_notes_and_google_title_2: 'Joogan rauha',
  components_notes_and_google_title_3: 'Pilates-keskivartalo',
  media_content_section_multi_1_subheader_text: 'Koulutusvideot',
  media_content_section_multi_2_subheader_text: 'Joogavideot',
  media_content_section_multi_3_subheader_text: 'Pilates-videot',
  text_media_1: 'Miehet',
  text_media_2: 'Naiset',
  page_media_content_menu_biceps: 'Hauislihas',
  page_media_content_menu_triceps: 'Ojentaja',
  page_media_content_menu_back: 'Takaisin',
  page_media_content_menu_chest: 'Rintakehä',
  page_media_content_menu_legs: 'Jalat',
  page_media_content_menu_shoulders: 'Olkapäät',
  page_media_content_menu_abdominals: 'Vatsalihakset',
  components_text1_subheader_text: 'Terveellinen ruokavalio aktiiviseen elämään',
  components_text1_span_text: 'Terveellisiä reseptejä, jotka tukevat harjoitteluasi ja parantavat hyvinvointiasi.',
  components_footer_text: 'Vahvista kehoasi, tasapainota mieltäsi ja liiku merkityksellisesti – sinun paikkasi kuntosalille, joogalle ja pilatekselle.',
};